module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content",
    staticStyle: {
      "background-color": "#EBECF1"
    }
  }, [_c('div', [_c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": true,
      "is-full-page": true
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('form', {
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "box-footer",
    staticStyle: {
      "padding-left": "15px",
      "display": "flex",
      "justify-content": "space-between"
    }
  }, [_c('button', {
    staticClass: "fuente btn btn-primary fs-13",
    attrs: {
      "type": "button",
      "data-toggle": "modal",
      "data-target": "#modalNuevo"
    },
    on: {
      "click": function($event) {
        return _vm.limpiar()
      }
    }
  }, [_vm._v("Nuevo Registro")]), _vm._v(" "), _c('button', {
    staticClass: "fuente btn btn-success fs-13",
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "20px",
      "min-width": "200px",
      "color": "white",
      "cursor": "pointer",
      "padding": "6px 15px",
      "border": "none",
      "border-radius": "5px",
      "box-shadow": "0 2px 5px rgba(0, 0, 0, 0.2)",
      "align-items": "center",
      "transition": "background-color 0.3s"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.exportToExcel
    }
  }, [_c('i', {
    staticClass: "fab fa-microsoft",
    staticStyle: {
      "margin-right": "5px",
      "font-size": "1.4em",
      "color": "white"
    }
  }), _vm._v("                  \n                Descargar Excel\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "fuente col-xs-12 table-responsive"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('table', {
    staticClass: "fuente fs-12 table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "tablaDetalle_info",
      "role": "grid",
      "id": "tablaDetalle"
    }
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.trabs), function(item) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(item.cont))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.dni))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.nombres) + " " + _vm._s(item.apePaterno) + " " + _vm._s(item.apeMaterno))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.cargo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.correo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.celular))]), _vm._v(" "), _c('td', {
      staticClass: "table-center-header"
    }, [_vm._v(_vm._s(item.jefatura))]), _vm._v(" "), _c('td', {
      staticClass: "table-center-header"
    }, [_c('span', {
      staticClass: "badge bg-blue",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "data-toggle": "modal",
        "data-target": "#modalNuevo"
      },
      on: {
        "click": function($event) {
          return _vm.ver(item)
        }
      }
    }, [_vm._v("O")])]), _vm._v(" "), _c('td', {
      staticClass: "table-center-header"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'usuarios' /*, params: { idTrab: item.idTrabajador }*/
        }
      }
    }, [_c('span', {
      staticClass: "badge bg-yellow",
      on: {
        "click": function($event) {
          return _vm.enviar(item)
        }
      }
    }, [_vm._v("V")])])], 1), _vm._v(" "), _c('td', {
      staticClass: "table-center-header"
    }, [_c('span', {
      staticClass: "badge bg-red",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "data-toggle": "modal",
        "data-target": "#modalAnular"
      },
      on: {
        "click": function($event) {
          return _vm.verAnular(item)
        }
      }
    }, [_vm._v("X")])]), _vm._v(" "), _c('td', {
      staticClass: "table-center-header"
    }, [_c('span', {
      staticClass: "badge bg-grey",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "data-toggle": "modal",
        "data-target": "#modalPensionar"
      },
      on: {
        "click": function($event) {
          return _vm.verPensionar(item)
        }
      }
    }, [_vm._v("P")])])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "fuente col-md-12",
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.error.desError) + "\n                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "modalNuevo",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('form', [_c('div', {
    staticClass: "modal-header"
  }, [_vm._m(2), _vm._v(" "), _c('h4', {
    staticClass: "fuente modal-title m-t-10",
    attrs: {
      "id": "myModalLabel"
    }
  }, [_vm._v(_vm._s(_vm.texto))])]), _vm._v(" "), _c('div', {
    staticClass: "fuente modal-body fs-12"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_vm._v("\n                          N° de DNI (*)\n                          "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.trab.dni),
      expression: "trab.dni"
    }],
    staticClass: "form-control fuente m-t-10 m-b-10",
    attrs: {
      "type": "text",
      "required": "true"
    },
    domProps: {
      "value": (_vm.trab.dni)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.trab, "dni", $event.target.value)
      }, _vm.handleDniInput]
    }
  }), _vm._v(" "), (_vm.dniLengthError) ? _c('span', {
    staticClass: "formatMensajeError1"
  }, [_vm._v("El DNI debe ser de 8 dígitos")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_vm._v("\n                          Fecha de Nacimiento\n                          "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.trab.fecNacimiento),
      expression: "trab.fecNacimiento"
    }],
    staticClass: "form-control fuente m-t-10",
    attrs: {
      "type": "date",
      "required": "true"
    },
    domProps: {
      "value": (_vm.trab.fecNacimiento)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.trab, "fecNacimiento", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 m-t-10"
  }, [_vm._v("\n                          Nombres (*)\n                          "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.trab.nombres),
      expression: "trab.nombres"
    }],
    staticClass: "form-control fuente m-t-10 m-b-10",
    attrs: {
      "type": "text",
      "required": "true"
    },
    domProps: {
      "value": (_vm.trab.nombres)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.trab, "nombres", $event.target.value)
      }, _vm.handleNombresInput]
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_vm._v("\n                          Apellido Paterno (*)\n                          "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.trab.apePaterno),
      expression: "trab.apePaterno"
    }],
    staticClass: "form-control fuente m-t-10",
    attrs: {
      "type": "text",
      "required": "true"
    },
    domProps: {
      "value": (_vm.trab.apePaterno)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.trab, "apePaterno", $event.target.value)
      }, _vm.handleApePaternoInput]
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_vm._v("\n                          Apellido Materno (*)\n                          "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.trab.apeMaterno),
      expression: "trab.apeMaterno"
    }],
    staticClass: "form-control fuente m-t-10",
    attrs: {
      "type": "text",
      "required": "true"
    },
    domProps: {
      "value": (_vm.trab.apeMaterno)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.trab, "apeMaterno", $event.target.value)
      }, _vm.handleApeMaternoInput]
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 m-t-10"
  }, [_vm._v("\n                          Cargo (*)\n                          "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.trab.cargo),
      expression: "trab.cargo"
    }],
    staticClass: "form-control fuente m-t-10",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.trab.cargo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.trab, "cargo", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 m-t-10"
  }, [_vm._v("\n                          Anexo\n                          "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.trab.anexo),
      expression: "trab.anexo"
    }],
    staticClass: "form-control fuente m-t-10",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.trab.anexo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.trab, "anexo", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 m-t-10"
  }, [_vm._v("\n                          Correo (*)\n                          "), _c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.trab.correo),
      expression: "trab.correo"
    }],
    staticClass: "form-control fuente m-t-10",
    attrs: {
      "type": "email",
      "required": "true",
      "placeholder": "example@tc.gob.pe"
    },
    domProps: {
      "value": (_vm.trab.correo)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.trab, "correo", $event.target.value)
      }, _vm.handleCorreoInput]
    }
  }), _vm._v(" "), (_vm.mensajeCorreoError) ? _c('span', {
    staticClass: "formatMensajeError2"
  }, [_vm._v(_vm._s(_vm.mensajeCorreoError))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 m-t-10"
  }, [_vm._v("\n                          Nro. Celular\n                          "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.trab.celular),
      expression: "trab.celular"
    }],
    staticClass: "form-control fuente m-t-10",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.trab.celular)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.trab, "celular", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 m-t-20"
  }, [_vm._v("\n                          Jefatura\n                          "), _c('div', {
    staticClass: "m-t-10 m-l-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.trab.jefatura),
      expression: "trab.jefatura"
    }],
    attrs: {
      "type": "checkbox",
      "true-value": "1",
      "false-value": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.trab.jefatura) ? _vm._i(_vm.trab.jefatura, null) > -1 : _vm._q(_vm.trab.jefatura, "1")
    },
    on: {
      "change": function($event) {
        var $$a = _vm.trab.jefatura,
          $$el = $event.target,
          $$c = $$el.checked ? ("1") : ("");
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.trab, "jefatura", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.trab, "jefatura", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.trab, "jefatura", $$c)
        }
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 m-t-15"
  }, [_vm._v("\n                          Sigla\n                          "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.trab.sigla),
      expression: "trab.sigla"
    }],
    staticClass: "form-control fuente m-t-10",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.trab.sigla)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.trab, "sigla", $event.target.value)
      }, _vm.handleSiglaInput]
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.mensajeLimiteSigla))])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "fuente btn btn-primary fs-13",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "disabled": _vm.isButtonDisabled || !_vm.trab.nombres || !_vm.trab.apePaterno || !_vm.trab.apeMaterno || !_vm.trab.cargo || !_vm.trab.correo,
      "title": (_vm.isButtonDisabled || !_vm.trab.nombres || !_vm.trab.apePaterno || !_vm.trab.apeMaterno || !_vm.trab.cargo || !_vm.trab.correo) ? 'Para guardar, complete correctamente los campos requeridos (*)' : ''
    },
    on: {
      "click": function($event) {
        return _vm.merge()
      }
    }
  }, [_vm._v("Guardar\n                        Cambios")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "modalAnular",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('form', [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "fuente modal-body"
  }, [_vm._v("\n                      Se anulará el siguiente trabajador: " + _vm._s(_vm.trab.nombres) + " " + _vm._s(_vm.trab.apePaterno) + " " + _vm._s(_vm.trab.apeMaterno)), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "fuente btn btn-danger fs-13",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.merge()
      }
    }
  }, [_vm._v("Anular Trabajador")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "modalPensionar",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('form', [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "fuente modal-body"
  }, [_vm._v("\n                      Se pensionará al trabajador: " + _vm._s(_vm.trab.nombres) + " " + _vm._s(_vm.trab.apePaterno) + " " + _vm._s(_vm.trab.apeMaterno)), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "fuente btn btn-danger fs-13",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.merge()
      }
    }
  }, [_vm._v("Pensionar Trabajador")])])])])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "fuente box-title p-t-10"
  }, [_vm._v("MANTENIMIENTO DEL PERSONAL")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticClass: "sorting_asc",
    attrs: {
      "aria-label": "ITEM",
      "aria-sort": "ascending",
      "aria-controls": "tablaDetalle",
      "tabindex": "0"
    }
  }, [_vm._v("ITEM")]), _vm._v(" "), _c('th', {
    staticClass: "sorting_asc",
    attrs: {
      "aria-label": "DNI",
      "aria-sort": "ascending",
      "aria-controls": "tablaDetalle",
      "tabindex": "0"
    }
  }, [_vm._v("DNI")]), _vm._v(" "), _c('th', {
    staticClass: "sorting_asc",
    attrs: {
      "aria-label": "NOMBRE",
      "aria-controls": "tablaDetalle",
      "tabindex": "0"
    }
  }, [_vm._v("NOMBRE\n                        ")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    attrs: {
      "aria-label": "CARGO",
      "aria-controls": "tablaDetalle",
      "tabindex": "0"
    }
  }, [_vm._v("CARGO")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    attrs: {
      "aria-label": "CORREO",
      "aria-controls": "tablaDetalle",
      "tabindex": "0"
    }
  }, [_vm._v("CORREO")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    attrs: {
      "aria-label": "NRO. CELULAR",
      "aria-controls": "tablaDetalle",
      "tabindex": "0"
    }
  }, [_vm._v("NRO.\n                          CELULAR")]), _vm._v(" "), _c('th', {
    staticClass: "sorting table-center-header",
    attrs: {
      "aria-label": "JEFATURA",
      "aria-controls": "tablaDetalle",
      "tabindex": "0"
    }
  }, [_vm._v("JEFATURA")]), _vm._v(" "), _c('th', {
    staticClass: "sorting table-center-header",
    attrs: {
      "aria-label": "MODIFICAR",
      "aria-controls": "tablaDetalle",
      "tabindex": "0"
    }
  }, [_vm._v("MODIFICAR\n                        ")]), _vm._v(" "), _c('th', {
    staticClass: "sorting table-center-header",
    attrs: {
      "aria-label": "DETALLE",
      "aria-controls": "tablaDetalle",
      "tabindex": "0"
    }
  }, [_vm._v("DETALLE")]), _vm._v(" "), _c('th', {
    staticClass: "sorting table-center-header",
    attrs: {
      "aria-label": "ANULAR",
      "aria-controls": "tablaDetalle",
      "tabindex": "0"
    }
  }, [_vm._v("ANULAR")]), _vm._v(" "), _c('th', {
    staticClass: "sorting table-center-header",
    attrs: {
      "aria-label": "PENSIONAR",
      "aria-controls": "tablaDetalle",
      "tabindex": "0"
    }
  }, [_vm._v("PENSIONAR\n                        ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("X")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('h4', {
    staticClass: "fuente modal-title m-t-10",
    attrs: {
      "id": "myModalLabel"
    }
  }, [_vm._v("Anular Trabajador")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('h4', {
    staticClass: "fuente modal-title m-t-10",
    attrs: {
      "id": "myModalLabel"
    }
  }, [_vm._v("Pensionar Trabajador")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-30e24120"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Trabajadores.vue
// module id = 335
// module chunks = 1